import React, { useState } from "react";
import { Modal, Form, Field, Input, Button } from "../../../groundworkui-ui";
import axiosClient from "../../../utilities/axios_client";

const DeploymentEnvironmentsFormModal = ({ projectId, onClose, onSuccess }) => {
  const [name, setName] = useState();
  const [submitting, setSubmitting] = useState(false);

  const handleCreate = () => {
    setSubmitting(true);
    axiosClient
      .post(`/projects/${projectId}/deployment_environments`, {
        deployment_environment: { name },
      })
      .then((response) => {
        if (onSuccess) {
          onSuccess(response.data);
        }
      })
      .catch((error) => {
        window.alert(error.message);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <Modal onClose={onClose}>
      <div>
        <h1 className="text-3xl font-bold">New Deployment Environment</h1>
        <Form>
          <Field>
            <label htmlFor="name">Name</label>
            <Input
              type="text"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Field>
          <div>
            <Button type="primary" loading={submitting} onClick={handleCreate}>
              Create
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default DeploymentEnvironmentsFormModal;
